var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-check" }, [
    _c("input", {
      staticClass: "form-check-input",
      attrs: { type: "checkbox", id: _vm.name, name: _vm.name },
      domProps: { checked: _vm.modelValue },
      on: { change: _vm.onChange },
    }),
    _vm._v(" "),
    _c(
      "label",
      { staticClass: "form-check-label", attrs: { for: _vm.name } },
      [
        _vm._t("default", function () {
          return [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.label ||
                    (_vm.modelValue ? _vm.checkedLabel : _vm.uncheckedLabel)
                ) +
                "\n        "
            ),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }